module.exports = __webpack_public_path__ + "static/media/  (124).65444c21.jpg";